import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Phone modals have to leave the scrolling page. On iOS a position:fixed
 * layer inside .app-scroll is trapped under the header and the tab bar.
 * Portaling to document.body makes the safe-area offsets apply to the screen.
 */
export default function ModalLayer({ children, style, onClick, className = '' }) {
  useEffect(() => {
    const scroller = document.querySelector('.app-scroll');
    const previous = scroller ? scroller.style.overflow : '';
    if (scroller) scroller.style.overflow = 'hidden';
    return () => {
      if (scroller) scroller.style.overflow = previous;
    };
  }, []);

  const node = (
    <div
      className={`app-modal-layer${className ? ` ${className}` : ''}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );

  if (typeof document === 'undefined') return node;
  return createPortal(node, document.body);
}
